import { BlogsArticleVideoAppComponenta } from "../../../defenitions/blogsAutoFeed/components/blogsArticleVideoAppComponenta";
import { SiteVideoData } from "../../../interfaces";
import { getQueryStringValue } from "../../../widgetsUtils";
import { AbroadBlocked } from "./abroadBlockedVideo";
import { GenericInlineVideoPlayer } from "./genericInlineVideoPlayer";

interface SiteVideoInlineProps {
    data: SiteVideoData;
    width?: number;
    height?: number;
    runArticleAutoPlayLogic?: boolean;
    hideVideoAds?: boolean;
    isShareButton?: boolean;
    isArticle?: boolean;
    articleId?: string;
    applyStickyness: boolean;
    articleType?: string;
    videoShareLink?: string;
    videoCategoryId?: string;
    adIndex?: number;
    videoSettings?: SiteVideoSettings
    onSelect?: () => void;
    onPlayStarted?: () => void;
    onPlayStopped?: () => void;
    onVideoEnded?: (e) => void;
    onVideoError?: () => void;
    onPlayerLoaded?: (player: any) => void;
}

export interface SiteVideoSettings {
    isVideoLightbox?: boolean
    hideVideoAds?: boolean
}
export class SiteVideoInline extends React.Component<SiteVideoInlineProps, {}> {
    public static siteScriptName = "SiteVideoInline";

    render() {
        const { data, videoCategoryId } = this.props;
        const isAbroad = typeof window !== "undefined" && window.isAbroad;
        if (data.blockAbroadViews && isAbroad) {
            return <AbroadBlocked poster={data.poster} />;
        }

        if (
            typeof window !== "undefined" &&
            getQueryStringValue("IsApp") &&
            !window.disableAppNativeVideo
        ) {
            return (
                <BlogsArticleVideoAppComponenta
                    data={data}
                    videoCategoryId={videoCategoryId}
                />
            );
        }

        return <GenericInlineVideoPlayer {...this.props} />;
    }
}
